export const STATUS_VOTE = {
  LIKED: 'liked',
  DISLIKED: 'disliked',
  NOT_VOTE: 'notVote',
};
